export const noCodePoints = [
    { x: 0, y: 90, label: "Validation Complete\nWeek 2" },
    { x: 20, y: 80, label: "MVP Live\nWeek 8" },
    { x: 40, y: 60, label: "Rapid Iteration\nWeek 10" },
    { x: 60, y: 40, label: "First Paying Users\nWeek 12" },
    { x: 80, y: 25 },
  ];
  
  export const customCodePoints = [
    { x: 0, y: 90 },
    { x: 100, y: 80, label: "MVP Launch\nWeek 30" },
  ];
  
